export const allHtmlTagsRegexp = new RegExp(/<\/?[^>]+(>|$)/, 'g');

export const allNewLineTags = new RegExp(/\/n/, 'g');

export const allClosePTags = new RegExp(/<\/p>/, 'g');

export const unnecessarySeparator = new RegExp(/\/\/+/, 'g');
